var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "project-container-wrapper" }, [
    _c("div", { staticClass: "project-container" }, [
      _c(
        "h4",
        [
          _c("HKLLeftRight", {
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.heading))]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fa fa-refresh dark flat icon_refresh",
                      on: {
                        click: function () {
                          return _vm.loadProjectTable()
                        },
                      },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "right",
                fn: function () {
                  return [
                    _c("HKLButton", {
                      staticClass: "btn-reset",
                      attrs: { action: "resetFilter", color: "darkblue" },
                      on: {
                        click: function () {
                          return _vm.resetFilterObject()
                        },
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "project-table" }, [
        _c("table", { staticClass: "hover" }, [
          _c("thead", [
            _c(
              "tr",
              _vm._l(_vm.itemHeaders, function (header) {
                return _c(
                  "th",
                  {
                    key: header.code,
                    class: header.class,
                    on: {
                      click: function () {
                        return _vm.sortBy(header.code, header.rank)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(header.name) +
                        " " +
                        _vm._s(
                          _vm.orderbyAttr === header.code
                            ? !_vm.reverse
                              ? "▼"
                              : "▲"
                            : null
                        ) +
                        "\n            "
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "tr",
              _vm._l(_vm.itemHeaders, function (header) {
                return _c(
                  "th",
                  { key: header.code },
                  [
                    _c(
                      header.filterComponent,
                      _vm._b(
                        {
                          tag: "component",
                          model: {
                            value: _vm.filterObject[header.code],
                            callback: function ($$v) {
                              _vm.$set(_vm.filterObject, header.code, $$v)
                            },
                            expression: "filterObject[header.code]",
                          },
                        },
                        "component",
                        header.filterComponentAttrs || {},
                        false
                      )
                    ),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.filteredItems, function (item) {
              return _c(
                "tr",
                { key: item.id, class: { bold_text: item.isPin } },
                [
                  _c("td", [
                    _c(
                      "a",
                      {
                        staticClass: "link_text",
                        class: { text_red: item.highlightNumber },
                        on: {
                          click: function () {
                            return _vm.navToProjectPage(item)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.number))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "a",
                        {
                          staticClass: "link_text",
                          on: {
                            click: function () {
                              return _vm.navToProjectPage(item)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.poName))]
                      ),
                      _vm._v(" "),
                      item.hasNewDoc
                        ? _c("HKLDocBadge", { attrs: { inline: true } })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(item.site))]),
                  _vm._v(" "),
                  _vm.showProjectInfo(item)
                    ? _c(
                        "td",
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.curSubmission) +
                              "\n              "
                          ),
                          item.isPin
                            ? _c("HKLPinBadge", { attrs: { inline: true } })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c("td", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("emptyValue")) +
                            "\n            "
                        ),
                      ]),
                  _vm._v(" "),
                  _vm.showProjectInfo(item)
                    ? _c("td", [
                        _c(
                          "a",
                          {
                            staticClass: "no-finger",
                            attrs: {
                              title:
                                item.curSubmStatusUpdatedDate &&
                                "Status changed on " +
                                  _vm.dateUtil.formatDate(
                                    item.curSubmStatusUpdatedDate,
                                    true,
                                    false
                                  ),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(item.curSubmStatus || _vm.$t("emptyValue"))
                            ),
                          ]
                        ),
                      ])
                    : _c("td", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("emptyValue")) +
                            "\n            "
                        ),
                      ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "number_text" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          (item.inviteDate &&
                            _vm.dateUtil.formatDate(
                              item.inviteDate,
                              true,
                              true
                            )) ||
                            _vm.$t("emptyValue")
                        ) +
                        "\n            "
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }